import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export const OverviewRoutes = {
  path: 'overview',
  async getComponent (nextState) {
    const {
      default: OverviewContainer
    } = await import(/* webpackChunkName: "overview" */ './containers/OverviewContainer.tsx')
      .catch(handleChunkLoadError);
    return OverviewContainer;
  },
  getData: ({ context: { props } }) => {
    return {
      ...props,
      section: 'overview'
    };
  },
  children: [
    {
      path: '',
      async getComponent (nextState) {
        const {
          default: OverviewContent
        } = await import(/* webpackChunkName: "overview" */ './containers/OverviewContent.tsx')
          .catch(handleChunkLoadError);
        return OverviewContent;
      },
      getData: ({ context: { props } }) => props
    }
  ]
};

export const OptimizeRoutes = {
  path: 'optimize',
  async getComponent (nextState) {
    const {
      default: OverviewContainer
    } = await import(/* webpackChunkName: "optimize" */ './containers/OverviewContainer.tsx')
      .catch(handleChunkLoadError);
    return OverviewContainer;
  },
  getData: ({ context: { props } }) => {
    return {
      ...props,
      section: 'optimize'
    };
  },
  children: [
    {
      path: '',
      async getComponent (nextState) {
        const {
          default: OptimizePage
        } = await import(/* webpackChunkName: "optimize" */ './containers/OptimizePage.tsx')
          .catch(handleChunkLoadError);
        return OptimizePage;
      },
      getData: ({ context: { props } }) => props
    }
  ]
};

export const HomeRoutes = {
  path: 'home',
  async getComponent (nextState) {
    const {
      default: OverviewContainer
    } = await import(/* webpackChunkName: "home" */ './containers/OverviewContainer.tsx')
      .catch(handleChunkLoadError);
    return OverviewContainer;
  },
  getData: ({ context: { props } }) => {
    return {
      ...props,
      section: 'home'
    };
  },
  children: [
    {
      path: '',
      async getComponent (nextState) {
        const {
          default: HomePage
        } = await import(/* webpackChunkName: "home" */ './containers/HomePage.tsx')
          .catch(handleChunkLoadError);
        return HomePage;
      },
      getData: ({ context: { props } }) => props
    }
  ]
};
